import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mrsoftapps-student-record-spinner',
  templateUrl: './student-record-spinner.component.html',
  styleUrls: ['./student-record-spinner.component.scss']
})
export class StudentRecordSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
